import { useCallback } from 'react';
import { axiosInstance, responseBody, getEndpoint } from '../index';
import { ConfigType } from '../../models/api.interface';
import { useDeactivateSession } from './useDeactivateSession';
export const api = <BodyData, ResponseData>(
  // <BodyData> and <ResponseData> are "generic types" that are passed so that we can expect
  // to send/receive whatever data we want.
  verb: 'post' | 'patch' | 'get',
  query: string,
  config?: ConfigType,
) => {
  const axiosRequest = (
    url: string,
    body: BodyData,
    config: ConfigType | undefined,
  ) => {
    return axiosInstance
      .request({ url, data: body, method: verb, ...config })
      .then(responseBody);
  };

  const deactivate = useDeactivateSession();

  const exec = useCallback(
    async (data: BodyData): Promise<ResponseData> => {
      try {
        return await axiosRequest(getEndpoint(query), data, config);
      }
      catch (error: any) {
        // 401 on a login endpoint means wrong credentials, not an expired session —
        // let the form handle it and show the error message to the user.
        if (error?.response?.status === 401 && query !== 'login' && query !== 'staff_login') {
          deactivate();
        }
        throw error;
      }
    },
    [config, query, verb, deactivate],
  );

  return exec;
};
